// @flow
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';

import RadioConfigurationStep from 'common/domain/RadioConfigurationStep';
import ActionBar from '../components/ActionBar';
import GeneralInformations from './radioInformationForm/GeneralInformations';
import TechnologyDirector from './radioInformationForm/TechnologyDirector';
import WebAgency from './radioInformationForm/WebAgency';
import WebPlayer from './radioInformationForm/WebPlayer';
import { INITIAL_DATA } from '../domain/RadioInformationForm';
import type { RadioInformationFormData, RadioInformationFormSection } from '../domain/RadioInformationForm';

type Props = {
  onNextStep: () => void,
  onSaveStep: (step: RadioConfigurationStep) => void,
  stepData: RadioInformationFormData,
  t: any,
}

type State = {
  data: RadioInformationFormData;
};

class RadioInformationForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    if (props.stepData) {
      this.state = {
        data: props.stepData,
      };
    } else {
      this.state = {
        data: INITIAL_DATA,
      };
    }
  }

  onChange = (key: string, value: RadioInformationFormSection) => {
    this.setState({
      data: {
        ...this.state.data,
        [key]: value,
      },
    });
  };

  onSubmit = (e: Event) => {
    e.preventDefault();
    const configuration = RadioConfigurationStep.of('FORM', this.state.data);
    this.props.onSaveStep(configuration);
  }

  render() {
    const { onNextStep, t } = this.props;
    const { generalInformations, technologyDirector, webPlayer, webAgency } = this.state.data;

    return (
      <form onSubmit={this.onSubmit}>
        <GeneralInformations onChange={v => this.onChange('generalInformations', v)} data={generalInformations} />
        <TechnologyDirector onChange={v => this.onChange('technologyDirector', v)} data={technologyDirector} />
        <WebAgency onChange={v => this.onChange('webAgency', v)} data={webAgency} />
        <WebPlayer onChange={v => this.onChange('webPlayer', v)} data={webPlayer} />
        <ActionBar onActionClick={onNextStep} actionText={t('next')}>
          <RaisedButton
            label={t('save')}
            primary
            type="submit"
          />
        </ActionBar>
      </form>
    );
  }
}

export default translate('radioConfiguration')(RadioInformationForm);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/RadioInformationForm.js